
namespace SP {
    export async function Notify(title: string, description: string, group: number, severity: number = 1) {
        var result:any = await SP.post("/api/v1/notification/create", { title: title, description: description, recipientGroup: group, severity: severity });
        if (result.status == 200) return true;
        await SP.alertX(result.msg);
        return false;
    }

    export async function alertX(message: string) : Promise<any> {
        await (new DialogBox(false)).prompt(message, true);
    }

    export async function confirmX(message: string): Promise<any> {
        var dialog = new DialogBox(true);
        var result = await dialog.prompt(message, false);
        console.log("Result:", result);
        return result;
    }
}

namespace SP.Notification {
    export async function Notify(title: string, description: string, group: number, severity: number = 1) {
        var result: any = await SP.post("/api/v1/notification/create", { title: title, description: description, recipientGroup: group, severity: severity });
        if (result.status == 200) return true;
        await SP.alertX(result.msg);
        return false;
    }

    export async function GetNotifications(all: boolean, count: number, page: number = 1) {
        return await SP.get<NotificationPageResult>(`/api/v1/notification/list?all=${all}&pagesize=${count}&p=${page}`);
    }

    export async function DismissNotifications(id: string) {
        return await SP.get<NotificationPageResult>(`/api/v1/notification/dismiss/${id ?? ""}`);
    }
}

